module.exports = __webpack_public_path__ + "static/media/Portrait-10241.8a9e7f51.jpg";